import {
  Dataset,
  FileStorage,
  Folder,
  ObjectType,
  Predictor,
  Project,
} from 'app/store/types'
import {
  DATASET_STATUS,
  PROJECT_STATUS,
  PREDICTOR_STATUS,
  OBJECT_TYPE,
} from 'app/constants'

export const isProjectIncompleteView = (project: Project) => {
  switch (project.executionStatus) {
    case PROJECT_STATUS.RUNNING:
      return true
    default:
      return false
  }
}

export const isMpoProjectIncompleteView = (mpoProject: Project) => {
  switch (mpoProject.executionStatus) {
    case PROJECT_STATUS.RUNNING:
      return true
    default:
      return false
  }
}

export const isDatasetIncompleteView = (dataset: Dataset) => {
  switch (dataset.status) {
    case DATASET_STATUS.PREPARING:
    case DATASET_STATUS.PREPARING_IN_AI:
      return true
    default:
      return false
  }
}

export const isPredictorIncompleteView = (predictor: Predictor) => {
  switch (predictor.status) {
    case PREDICTOR_STATUS.TRAINING:
      return true
    default:
      return false
  }
}

export const isProjectShareable = (project: Project) => {
  return project.shareable
}

export const isMpoProjectShareable = (project: Project) => {
  return project.shareable
}

export const isPredictorShareable = (predictor: Predictor) => {
  return predictor.shareable
}

export const isDatasetShareable = (dataset: Dataset) => {
  return dataset.shareable
}

export const isFileStorageShareable = (file: FileStorage) => {
  return file.shareable
}

export const isFolderShareable = (folder: Folder) => {
  return folder.shareable
}

export const isProjectInProgress = (project: Project) => {
  switch (project.executionStatus) {
    case PROJECT_STATUS.RUNNING:
    case PROJECT_STATUS.CANCELING:
    case PROJECT_STATUS.DELETING:
      return true
    default:
      return false
  }
}

export const isMpoProjectInProgress = (project: Project) => {
  switch (project.executionStatus) {
    case PROJECT_STATUS.RUNNING:
    case PROJECT_STATUS.CANCELING:
    case PROJECT_STATUS.DELETING:
      return true
    default:
      return false
  }
}

export const isPredictorInProgress = (predictor: Predictor) => {
  switch (predictor.status) {
    case PREDICTOR_STATUS.TRAINING:
    case PREDICTOR_STATUS.CANCELING:
    case PREDICTOR_STATUS.DELETING:
      return true
    default:
      return false
  }
}

export const isDatasetInProgress = (dataset: Dataset) => {
  switch (dataset.status) {
    case DATASET_STATUS.PREPARING:
    case DATASET_STATUS.PREPARING_IN_AI:
    case DATASET_STATUS.CANCELING:
    case DATASET_STATUS.DELETING:
      return true
    default:
      return false
  }
}

export const getProjectViewUrl = (project: Project) => {
  return isProjectIncompleteView(project)
    ? `/projects/${project.id}/read-only`
    : `/projects/${project.id}`
}

export const getMpoProjectViewUrl = (mpoProject: Project) => {
  return isMpoProjectIncompleteView(mpoProject)
    ? `/mpo-projects/${mpoProject.id}/read-only`
    : `/mpo-projects/${mpoProject.id}`
}

export const getDatasetViewUrl = (dataset: Dataset) => {
  return isDatasetIncompleteView(dataset)
    ? `/datasets/${dataset.id}/read-only`
    : `/datasets/${dataset.id}`
}

export const getPredictorViewUrl = (predictor: Predictor) => {
  return isPredictorIncompleteView(predictor)
    ? `/predictors/${predictor.id}/read-only`
    : `/predictors/${predictor.id}`
}

// Dataset 1, Predictor 2, Project 3, MPO 4, Folder 5
export const getObjectTypeViewUrl = (
  objectType: ObjectType,
  objectId: number
) => {
  switch (objectType) {
    case OBJECT_TYPE.DATASET:
      return `/datasets/${objectId}`
    case OBJECT_TYPE.PREDICTOR:
      return `/predictors/${objectId}`
    case OBJECT_TYPE.PROJECT:
      return `/projects/${objectId}`
    case OBJECT_TYPE.MPO_PROJECT:
      return `/mpo-projects/${objectId}`
    case OBJECT_TYPE.FOLDER:
      return `/folders/${objectId}`
    default:
      return ''
  }
}

export const getObjectTypeEndpoint = (objectType: ObjectType) => {
  switch (objectType) {
    case OBJECT_TYPE.DATASET:
      return 'dataset'
    case OBJECT_TYPE.PREDICTOR:
      return 'predictor'
    case OBJECT_TYPE.PROJECT:
      return 'project'
    case OBJECT_TYPE.MPO_PROJECT:
      return 'mpo-project'
    case OBJECT_TYPE.FOLDER:
      return 'folder'
    default:
      return ''
  }
}
